
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resultat",
      function () {
        return require("private-next-pages/resultat.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resultat"])
      });
    }
  